import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-patient-space-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule],
  templateUrl: './patient-space-layout.component.html',
  styleUrl: './patient-space-layout.component.scss',
})
export class PatientSpaceLayoutComponent {}
